import { setValue } from "../../lib/immutable_wrapper";
import { SET_TIERS, SET_SUBCONTRACTORS, SET_CUSTOMERS, SET_CUSTOMER_SEARCH } from "./tiersConstants";

const initialState = {
    tiers: [],
    subcontractors: [],
    customers: [],
    customerSearch: null,
};

export function tiers(state = initialState, action) {
    switch (action.type) {
        case SET_TIERS:
            return setValue(state, ["tiers"], action.tiers);
        case SET_SUBCONTRACTORS:
            return setValue(state, ["subcontractors"], action.subcontractors);
        case SET_CUSTOMERS:
            return setValue(state, ["customers"], action.customers);
        case SET_CUSTOMER_SEARCH:
            return setValue(state, ["customerSearch"], action.customerSearch);
        default:
            return state;
    }
}
